class Accordion extends HTMLElement {
  constructor() {
    super();
    this.items = [];
  }

  connectedCallback() {
    this._init();
  }

  _init() {
    this.items = [...this.querySelectorAll('num-accordion-item')];

    if (this.classList.contains('product__accordion') && this.items.length > 0) {
      this.items[0].setAttribute('data-open', 'true');
    } else {
      this.items.forEach((item) => item.setAttribute('data-open', 'false'));
    }

    this._attachEventListeners();
  }

  _attachEventListeners() {
    this.items.forEach((item) => {
      item.addEventListener('toggle', (event) => this._toggleItem(event.detail));
    });
  }

  _toggleItem(clickedItem) {
    const isOpen = clickedItem.getAttribute('data-open') === 'true';
    this.items.forEach((item) => item.setAttribute('data-open', 'false'));

    if (!isOpen) {
      clickedItem.setAttribute('data-open', 'true');
    }
  }
}

class AccordionItem extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.label = this.getAttribute('label');
    this.render();
  }

  render() {
    this.innerHTML = `
      <style>
        .accordion-item__panel {
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.2s ease-out;
        }
        .accordion-item[data-open="true"] .accordion-item__panel {
          max-height: 1000px;
        }
      </style>
      <div class="accordion-item" data-open="${this.getAttribute('data-open')}">
        <div class="accordion-item__label">
          <span>${this.label}</span>
          <button class="plusminus"> 
            <span class="plusminus-icon"></span> 
          </button>
        </div>
        <div class="accordion-item__panel">
          <div class="accordion-item__content">
            ${this.innerHTML}
          </div>
        </div>
      </div>
    `;

    this.querySelector('.accordion-item__label').addEventListener('click', () => {
      this.dispatchEvent(new CustomEvent('toggle', { detail: this }));
    });
  }

  static get observedAttributes() {
    return ['data-open'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-open' && oldValue !== newValue) {
      const panel = this.querySelector('.accordion-item__panel');
      if (panel) {
        panel.style.maxHeight = newValue === 'true' ? `${panel.scrollHeight}px` : '0';
      }
    }
  }
}

customElements.define('num-accordion', Accordion);
customElements.define('num-accordion-item', AccordionItem);
